import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { FileDownload, PictureAsPdf, TableChart, Code } from '@mui/icons-material';
import { fontSize } from '../../utils/accounting/styles';

export const FORMATS = [
  { key: 'pdf', label: 'PDF', icon: <PictureAsPdf fontSize="small" /> },
  { key: 'csv', label: 'CSV', icon: <TableChart fontSize="small" /> },
  { key: 'quickbooks', label: 'QuickBooks', icon: <TableChart fontSize="small" /> },
  { key: 'zoho', label: 'Zoho Books', icon: <TableChart fontSize="small" /> },
  { key: 'tally', label: 'Tally XML', icon: <Code fontSize="small" /> },
];

const ExportMenu = ({ onExport, formats = FORMATS, busy = false, label = 'Export' }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleExport = (format) => {
    setAnchorEl(null);
    if (onExport) onExport(format);
  };

  return (
    <>
      <Button
        variant="text"
        size="small"
        startIcon={<FileDownload />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={busy}
        sx={{ textTransform: 'none', fontSize: fontSize.xs }}
      >
        {busy ? 'Exporting…' : label}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {formats.map((f) => (
          <MenuItem key={f.key} onClick={() => handleExport(f.key)} sx={{ fontSize: fontSize.sm }}>
            <ListItemIcon>{f.icon}</ListItemIcon>
            <ListItemText>{f.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ExportMenu;
